import * as qs from 'query-string';
import { assign } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const updateUrl = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    const {
      custom: {
        totalPrice,
        smartReleasePrice,
        extensionPolePrice,
        lightGuardPrice,
        fasciaPrice,
        venetianValancePrice,
        measureInsurancePrice,
        trackPrice,
        ...custom
      },
    } = context;
    const url = qs.parseUrl(window.location.href).url;
    const currentParams = qs.parse(window.location.search);

    // Remove undefined/null/empty values to keep URL clean
    const cleanedCustom = Object.fromEntries(
      Object.entries(custom).filter(([_, value]) => 
        value !== undefined && value !== null && value !== ''
      )
    );

    const customParams = qs.parse(qs.stringify(cleanedCustom));
    const newParams = {
      ...currentParams,
      ...customParams,
    };
    const newUrl = `${url}?${qs.stringify(newParams)}`;
    window.history.replaceState(null, '', newUrl);
    return context;
  },
);
